/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Browser_Extensions_Cross_Title5Inputs */

const en_svc_browser_extensions_cross_title5 = /** @type {(inputs: Svc_Browser_Extensions_Cross_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cross-browser coverage`)
};

const ar_svc_browser_extensions_cross_title5 = /** @type {(inputs: Svc_Browser_Extensions_Cross_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تغطية متعددة المتصفحات`)
};

const bn_svc_browser_extensions_cross_title5 = /** @type {(inputs: Svc_Browser_Extensions_Cross_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ক্রস-ব্রাউজার কভারেজ`)
};

const de_svc_browser_extensions_cross_title5 = /** @type {(inputs: Svc_Browser_Extensions_Cross_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browserübergreifende Abdeckung`)
};

const es_svc_browser_extensions_cross_title5 = /** @type {(inputs: Svc_Browser_Extensions_Cross_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cobertura entre navegadores`)
};

const fr_svc_browser_extensions_cross_title5 = /** @type {(inputs: Svc_Browser_Extensions_Cross_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couverture multi-navigateurs`)
};

const pt_svc_browser_extensions_cross_title5 = /** @type {(inputs: Svc_Browser_Extensions_Cross_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cobertura entre navegadores`)
};

const zh_svc_browser_extensions_cross_title5 = /** @type {(inputs: Svc_Browser_Extensions_Cross_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`跨浏览器覆盖`)
};

const tr_svc_browser_extensions_cross_title5 = /** @type {(inputs: Svc_Browser_Extensions_Cross_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarayıcılar arası kapsam`)
};

const ru_svc_browser_extensions_cross_title5 = /** @type {(inputs: Svc_Browser_Extensions_Cross_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Кроссбраузерность`)
};

const pl_svc_browser_extensions_cross_title5 = /** @type {(inputs: Svc_Browser_Extensions_Cross_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zasięg w różnych przeglądarkach`)
};

/**
* | output |
* | --- |
* | "Cross-browser coverage" |
*
* @param {Svc_Browser_Extensions_Cross_Title5Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_browser_extensions_cross_title5 = /** @type {((inputs?: Svc_Browser_Extensions_Cross_Title5Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Browser_Extensions_Cross_Title5Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_browser_extensions_cross_title5(inputs)
	if (locale === "bn") return bn_svc_browser_extensions_cross_title5(inputs)
	if (locale === "de") return de_svc_browser_extensions_cross_title5(inputs)
	if (locale === "es") return es_svc_browser_extensions_cross_title5(inputs)
	if (locale === "fr") return fr_svc_browser_extensions_cross_title5(inputs)
	if (locale === "pt") return pt_svc_browser_extensions_cross_title5(inputs)
	if (locale === "zh") return zh_svc_browser_extensions_cross_title5(inputs)
	if (locale === "tr") return tr_svc_browser_extensions_cross_title5(inputs)
	if (locale === "ru") return ru_svc_browser_extensions_cross_title5(inputs)
	if (locale === "pl") return pl_svc_browser_extensions_cross_title5(inputs)
	return en_svc_browser_extensions_cross_title5(inputs)
});
export { svc_browser_extensions_cross_title5 as "svc_browser-extensions_CROSS_title" }